import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SelectColaborador from '../components/SelectColaborador';
import ModalGravarCliente from '../components/ModalGravarCliente';

// Pré-seleciona a pessoa do login (ganho de tempo): SDR logado → campo SDR;
// Closer/Admin → campos Closer E SDR com a própria pessoa. Segue editável.
function formNovaOportunidade() {
  const nome = localStorage.getItem('nomeUsuario') || '';
  const cargo = (localStorage.getItem('cargoUsuario') || '').toLowerCase();
  const ehCloser = cargo.includes('closer') || cargo.includes('admin');
  return {
    nome_cliente: '', telefone: '', etapa: 'lead',
    sdr: (cargo.includes('sdr') || ehCloser) ? nome : '',
    closer: ehCloser ? nome : '',
    // SDR logado já nasce com origem SDR; o detalhe (quem prospectou) é
    // preenchido sozinho no salvar a partir do campo SDR
    origem_lead: cargo.includes('sdr') ? 'SDR' : '',
    origem_detalhe: '',
  };
}

const ORIGENS_OP = ['Parceiros', 'SDR', 'Ativo', 'Cliente', 'Network', 'Rede Social', 'Anúncios', 'Site'];

const ETAPAS = [
  { key: 'lead',        label: 'Lead',        cor: '#6b7280', bg: '#f9fafb' },
  { key: '1contato',    label: '1º Contato',  cor: '#3b82f6', bg: '#eff6ff' },
  { key: 'viabilidade', label: 'Viabilidade', cor: '#f59e0b', bg: '#fffbeb' },
  { key: 'negociacao',  label: 'Negociação',  cor: '#8b5cf6', bg: '#f5f3ff' },
  { key: 'ganho',          label: 'Ganho',          cor: '#16a34a', bg: '#f0fdf4' },
  { key: 'perdido',        label: 'Perdido',        cor: '#dc2626', bg: '#fef2f2' },
  { key: 'sem-interacao',  label: 'Sem interação',  cor: '#9ca3af', bg: '#f3f4f6' },
];

const TAREFA_NOVA = { descricao: '', data_agendada: '', destinado_a: '', realizado: '', subagenda: 'comercial' };
const SUBAGENDAS_OP = [['', '📥 Geral'], ['administrativo', '🗂️ Administrativo'], ['comercial', '💼 Comercial'], ['cliente', '👥 Cliente'], ['demandas', '⚖️ Demandas Processuais'], ['pessoal', '🏠 Pessoal']];
const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };

function parseDataHora(val) {
  if (!val) return { data: '', hora: '' };
  const [data, hora] = val.includes('T') ? val.split('T') : [val, ''];
  return { data, hora: hora ? hora.slice(0, 5) : '' };
}
function combinarDataHora(data, hora) {
  if (!data) return '';
  return hora ? `${data}T${hora}` : data;
}
function DataHoraInput({ value, onChange, inpStyle }) {
  const { data, hora } = parseDataHora(value);
  function handleHora(e) {
    let v = e.target.value.replace(/[^0-9:]/g, '');
    // auto-insere : quando digita 4 dígitos sem ele
    if (/^\d{4}$/.test(v)) v = v.slice(0, 2) + ':' + v.slice(2);
    onChange(combinarDataHora(data, v));
  }
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <input type="date" value={data}
        onChange={e => onChange(combinarDataHora(e.target.value, hora))}
        style={{ ...inpStyle, flex: 1 }} />
      <input type="text" value={hora} placeholder="HH:MM" maxLength={5}
        onChange={handleHora}
        style={{ ...inpStyle, width: 70, flex: 'none' }} />
    </div>
  );
}

function token() { return localStorage.getItem('token'); }
function isAdmin() { return localStorage.getItem('nomeUsuario') === 'Vagner Freitas'; }

async function apiFetch(url, opts = {}) {
  const res = await fetch(url, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.erro || 'Erro');
  return data;
}

function fmtDt(iso) {
  if (!iso) return '—';
  if (iso.includes('T')) {
    const [datePart, timePart] = iso.split('T');
    const [ano, mes, dia] = datePart.split('-');
    return `${dia}/${mes}/${ano.slice(2)} ${timePart.slice(0, 5)}`;
  }
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano.slice(2)}`;
}
function fmtD(iso) { if (!iso) return ''; return new Date(iso).toLocaleDateString('pt-BR'); }

function statusTarefa(t) {
  if (t.realizado) return { label: 'Concluída', cor: '#16a34a', bg: '#f0fdf4' };
  if (!t.data_agendada) return { label: 'Sem data', cor: '#9ca3af', bg: '#f9fafb' };
  if (new Date(t.data_agendada) < new Date()) return { label: 'Atrasada', cor: '#dc2626', bg: '#fef2f2' };
  return { label: 'Pendente', cor: '#d97706', bg: '#fffbeb' };
}

function ModalDetalhe({ op, etapas, onFechar, onMover, onEditar, onExcluir, onGravarCliente }) {
  const navigate = useNavigate();
  const [tarefas, setTarefas] = useState([]);
  const [adicionando, setAdicionando] = useState(false);
  const [novaTarefa, setNovaTarefa] = useState({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' });
  const [salvando, setSalvando] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [confirmarExcTarefa, setConfirmarExcTarefa] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState('tarefas');

  const etapa = etapas.find(e => e.key === op.etapa) || etapas[0];

  const carregarTarefas = useCallback(() => {
    fetch(`/agenda?oportunidade_id=${op._id}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(data => setTarefas([...data].sort((a, b) => new Date(b.criado_em) - new Date(a.criado_em))))
      .catch(() => {});
  }, [op._id]);

  useEffect(() => { carregarTarefas(); }, [carregarTarefas]);

  async function salvarNova() {
    if (!novaTarefa.descricao.trim()) return alert('Preencha a descrição.');
    setSalvando(true);
    await fetch('/agenda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ ...novaTarefa, oportunidade_id: op._id, oportunidade_nome: op.nome_cliente }),
    });
    setSalvando(false);
    setNovaTarefa({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' });
    setAdicionando(false);
    carregarTarefas();
  }

  async function salvarEdicao(id) {
    await fetch(`/agenda/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify(editForm),
    });
    setEditandoId(null);
    carregarTarefas();
  }

  async function excluirTarefa() {
    await fetch(`/agenda/${confirmarExcTarefa}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmarExcTarefa(null);
    carregarTarefas();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}
      onClick={onFechar}>
      <div style={{ background: '#fff', borderRadius: 4, width: '100%', maxWidth: 600, maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }}
        onClick={e => e.stopPropagation()}>

        {/* Cabeçalho */}
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '4px 4px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ background: etapa.cor, color: '#fff', padding: '1px 8px', borderRadius: 10, fontSize: 11, fontWeight: 700 }}>{etapa.label}</span>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#fff', marginTop: 4 }}>{op.nome_cliente}</div>
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {op.telefone && <span>{op.telefone}</span>}
              {op.sdr && <span>SDR: {op.sdr}</span>}
              {op.closer && <span>Closer: {op.closer}</span>}
              {op.parceiro_nome && <span style={{ color: '#86efac', fontWeight: 700 }}>🤝 via {op.parceiro_nome}</span>}
              <span>Criado: {fmtD(op.criado_em)}</span>
            </div>
          </div>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8', lineHeight: 1 }}>×</button>
        </div>

        {/* Mover etapa */}
        <div style={{ padding: '6px 14px', borderBottom: '1px solid #e8eaed', display: 'flex', gap: 4, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: '#6b7280', marginRight: 4 }}>Mover para:</span>
          {etapas.filter(e => e.key !== op.etapa).map(e => (
            <button key={e.key} onClick={() => onMover(op, e.key)}
              style={{ background: e.cor, color: '#fff', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
              {e.label}
            </button>
          ))}
          <div style={{ flex: 1 }} />
          {op.telefone && localStorage.getItem('nomeUsuario') === 'Vagner Freitas' && (
            <button onClick={() => navigate(`/comunicacao?para_tel=${encodeURIComponent(op.telefone)}&para_nome=${encodeURIComponent(op.nome_cliente || '')}`)}
              title="Abre a Comunicação com este contato já preenchido — escolha o template, a data e agende (ou envie na hora)"
              style={{ background: '#0369a1', color: '#fff', padding: '4px 12px', borderRadius: 5, fontSize: 12, fontWeight: 700, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              📅 Agendar WhatsApp
            </button>
          )}
          <button onClick={() => onGravarCliente(op)}
            title="Cadastra o cliente (identificação, venda e origem) e move a oportunidade para Ganho"
            style={{ background: '#16a34a', color: '#fff', padding: '4px 12px', borderRadius: 5, fontSize: 12, fontWeight: 700, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            💾 Gravar Cliente
          </button>
        </div>

        {/* Abas */}
        <div style={{ display: 'flex', borderBottom: '1px solid #e8eaed', padding: '0 14px' }}>
          {[{ key: 'tarefas', label: `Tarefas (${tarefas.length})` }, { key: 'info', label: 'Informações' }].map(aba => (
            <button key={aba.key} onClick={() => setAbaAtiva(aba.key)}
              style={{ padding: '7px 12px', fontSize: 12, fontWeight: abaAtiva === aba.key ? 700 : 400, color: abaAtiva === aba.key ? '#0a1628' : '#6b7280', borderBottom: abaAtiva === aba.key ? '2px solid #0a1628' : '2px solid transparent', background: 'none', border: 'none', borderBottom: abaAtiva === aba.key ? '2px solid #0a1628' : '2px solid transparent', cursor: 'pointer' }}>
              {aba.label}
            </button>
          ))}
        </div>

        <div style={{ padding: '10px 14px' }}>
          {abaAtiva === 'tarefas' && (
            <div>
              {confirmarExcTarefa && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
                  <div style={{ background: '#fff', borderRadius: 4, padding: 20, maxWidth: 320, textAlign: 'center', border: '1px solid #c8d0da' }}>
                    <p style={{ fontSize: 13, marginBottom: 14 }}>Excluir esta tarefa?</p>
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                      <button onClick={excluirTarefa} style={{ background: '#dc2626', color: '#fff', padding: '4px 14px', borderRadius: 4, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 12 }}>Excluir</button>
                      <button onClick={() => setConfirmarExcTarefa(null)} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer', fontSize: 12 }}>Cancelar</button>
                    </div>
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                {!adicionando && (
                  <button onClick={() => setAdicionando(true)} style={{ background: '#0a1628', color: '#fff', padding: '3px 10px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
                    + Nova Tarefa
                  </button>
                )}
              </div>

              {adicionando && (
                <div style={{ background: '#f9fafb', borderRadius: 4, padding: 10, marginBottom: 8, border: '1px solid #c8d0da' }}>
                  <div style={{ display: 'grid', gap: 8 }}>
                    <div>
                      <label style={lbl}>Criado em</label>
                      <input value={new Date().toLocaleString('pt-BR')} readOnly style={{ ...inp, background: '#f3f4f6', color: '#9ca3af' }} />
                    </div>
                    <div>
                      <label style={lbl}>Descrição *</label>
                      <textarea value={novaTarefa.descricao} onChange={e => setNovaTarefa(f => ({ ...f, descricao: e.target.value }))} rows={2}
                        placeholder="Descreva o que precisa ser feito..."
                        style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      <div>
                        <label style={lbl}>Data <span style={{ fontWeight: 400, color: '#9ca3af' }}>(hora opcional)</span></label>
                        <DataHoraInput value={novaTarefa.data_agendada} onChange={v => setNovaTarefa(f => ({ ...f, data_agendada: v }))} inpStyle={inp} />
                      </div>
                      <div>
                        <label style={lbl}>Destinado a</label>
                        <SelectColaborador value={novaTarefa.destinado_a} onChange={v => setNovaTarefa(f => ({ ...f, destinado_a: v }))} placeholder="Selecione..." />
                      </div>
                    </div>
                    <div>
                      <label style={lbl}>Subagenda</label>
                      <select value={novaTarefa.subagenda || 'comercial'} onChange={e => setNovaTarefa(f => ({ ...f, subagenda: e.target.value }))} style={{ ...inp, width: '100%' }}>
                        {SUBAGENDAS_OP.map(([v, l]) => <option key={v || 'g'} value={v}>{l}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={lbl}>O que foi feito</label>
                      <textarea value={novaTarefa.realizado} onChange={e => setNovaTarefa(f => ({ ...f, realizado: e.target.value }))} rows={2}
                        placeholder="Preencherá após realização..."
                        style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, marginTop: 8, alignItems: 'center' }}>
                    <button onClick={salvarNova} disabled={salvando} style={{ background: '#0a1628', color: '#fff', padding: '3px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
                      {salvando ? 'Salvando...' : 'Salvar'}
                    </button>
                    <button onClick={() => { setAdicionando(false); setNovaTarefa({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' }); }} style={{ background: '#f3f4f6', color: '#374151', padding: '3px 10px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
                    <button type="button" onClick={() => setNovaTarefa(f => ({ ...f, favorita: !f.favorita }))} title="Favorita: aparece no filtro ⭐ da Agenda em qualquer dia" style={{ marginLeft: 'auto', background: novaTarefa.favorita ? '#fffbeb' : '#fff', color: novaTarefa.favorita ? '#b45309' : '#6b7280', border: `1px solid ${novaTarefa.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{novaTarefa.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}</button>
                    <button type="button" onClick={() => setNovaTarefa(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: novaTarefa.urgente ? '#fee2e2' : '#fff', color: novaTarefa.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${novaTarefa.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{novaTarefa.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
                  </div>
                </div>
              )}

              {tarefas.length === 0 && !adicionando && (
                <div style={{ textAlign: 'center', padding: 20, color: '#9ca3af', fontSize: 12, background: '#f9fafb', borderRadius: 4 }}>Nenhuma tarefa cadastrada.</div>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {tarefas.map(t => {
                  const status = statusTarefa(t);
                  const bloqueado = t.realizado && !isAdmin();
                  return (
                    <div key={t._id} style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: 10 }}>
                      {editandoId === t._id ? (
                        <div style={{ display: 'grid', gap: 8 }}>
                          <div>
                            <label style={lbl}>Descrição</label>
                            <textarea value={editForm.descricao || ''} onChange={e => setEditForm(f => ({ ...f, descricao: e.target.value }))} rows={2}
                              style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            <div>
                              <label style={lbl}>Data <span style={{ fontWeight: 400, color: '#9ca3af' }}>(hora opcional)</span></label>
                              <DataHoraInput value={editForm.data_agendada || ''} onChange={v => setEditForm(f => ({ ...f, data_agendada: v }))} inpStyle={inp} />
                            </div>
                            <div>
                              <label style={lbl}>Destinado a</label>
                              <SelectColaborador value={editForm.destinado_a || ''} onChange={v => setEditForm(f => ({ ...f, destinado_a: v }))} />
                            </div>
                          </div>
                          <div>
                            <label style={lbl}>O que foi feito</label>
                            <textarea value={editForm.realizado || ''} onChange={e => setEditForm(f => ({ ...f, realizado: e.target.value }))} rows={2}
                              style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                          </div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                            <button onClick={() => salvarEdicao(t._id)} style={{ background: '#0a1628', color: '#fff', padding: '3px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' }}>Salvar</button>
                            <button onClick={() => setEditandoId(null)} style={{ background: '#f3f4f6', color: '#374151', padding: '3px 10px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
                            <button type="button" onClick={() => setEditForm(f => ({ ...f, favorita: !f.favorita }))} title="Favorita: aparece no filtro ⭐ da Agenda em qualquer dia" style={{ marginLeft: 'auto', background: editForm.favorita ? '#fffbeb' : '#fff', color: editForm.favorita ? '#b45309' : '#6b7280', border: `1px solid ${editForm.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{editForm.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}</button>
                            <button type="button" onClick={() => setEditForm(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: editForm.urgente ? '#fee2e2' : '#fff', color: editForm.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${editForm.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{editForm.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                            <div style={{ fontSize: 11, color: '#9ca3af' }}>Criado em: {fmtDt(t.criado_em)}</div>
                            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                              <span style={{ background: status.bg, color: status.cor, padding: '1px 7px', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{status.label}</span>
                              {bloqueado ? (
                                <span style={{ fontSize: 11, color: '#dc2626', background: '#fef2f2', padding: '2px 6px', borderRadius: 4, fontWeight: 600 }}>Bloq.</span>
                              ) : (
                                <>
                                  <button onClick={() => { setEditandoId(t._id); setEditForm({ descricao: t.descricao, data_agendada: t.data_agendada, destinado_a: t.destinado_a, realizado: t.realizado, favorita: !!t.favorita, urgente: !!t.urgente }); }}
                                    style={{ background: '#f3f4f6', color: '#374151', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #d1d5db', cursor: 'pointer' }}>Editar</button>
                                  <button onClick={() => setConfirmarExcTarefa(t._id)} style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #fecaca', cursor: 'pointer' }}>Excluir</button>
                                </>
                              )}
                            </div>
                          </div>
                          <div style={{ fontSize: 13, color: '#111827', lineHeight: 1.5, marginBottom: 6 }}>{t.descricao}</div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
                            <div style={{ background: '#eff6ff', borderRadius: 3, padding: '5px 8px' }}>
                              <div style={{ fontSize: 10, color: '#3b82f6', fontWeight: 600 }}>DATA/HORA REALIZAÇÃO</div>
                              <div style={{ fontSize: 11, color: '#1e40af', marginTop: 1 }}>{fmtDt(t.data_agendada)}</div>
                            </div>
                            <div style={{ background: '#f5f3ff', borderRadius: 3, padding: '5px 8px' }}>
                              <div style={{ fontSize: 10, color: '#7c3aed', fontWeight: 600 }}>DESTINADO A</div>
                              <div style={{ fontSize: 11, color: '#6d28d9', marginTop: 1 }}>{t.destinado_a || '—'}</div>
                            </div>
                          </div>
                          <div style={{ background: t.realizado ? '#f0fdf4' : '#fafafa', borderRadius: 3, padding: '5px 8px', border: `1px solid ${t.realizado ? '#bbf7d0' : '#e5e7eb'}` }}>
                            <div style={{ fontSize: 10, color: t.realizado ? '#16a34a' : '#9ca3af', fontWeight: 600, marginBottom: 2 }}>O QUE FOI FEITO</div>
                            <div style={{ fontSize: 11, color: t.realizado ? '#15803d' : '#9ca3af' }}>{t.realizado || 'Ainda não preenchido'}</div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {abaAtiva === 'info' && (
            <div style={{ display: 'grid', gap: 8 }}>
              {[
                { label: 'Nome do Cliente', valor: op.nome_cliente },
                { label: 'Telefone', valor: op.telefone || '—' },
                { label: 'SDR', valor: op.sdr || '—' },
                { label: 'Closer', valor: op.closer || '—' },
                { label: 'Etapa', valor: etapa.label },
                { label: 'Criado em', valor: fmtDt(op.criado_em) },
              ].map(({ label, valor }) => (
                <div key={label} style={{ borderBottom: '1px solid #e8eaed', padding: '5px 0', display: 'flex', gap: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em', minWidth: 120 }}>{label}</div>
                  <div style={{ fontSize: 13, color: '#0a1628' }}>{valor}</div>
                </div>
              ))}
              <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                <button onClick={() => onEditar(op)} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', borderRadius: 4, fontWeight: 600, fontSize: 12, border: 'none', cursor: 'pointer' }}>Editar</button>
                <button onClick={() => onExcluir(op)} style={{ background: '#fef2f2', color: '#dc2626', padding: '4px 14px', borderRadius: 4, fontWeight: 600, fontSize: 12, border: '1px solid #fecaca', cursor: 'pointer' }}>Excluir</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function CRM() {
  const [searchParams] = useSearchParams();
  const [oportunidades, setOportunidades] = useState([]);
  const [filtroCloser, setFiltroCloser] = useState(localStorage.getItem('nomeUsuario') || '');
  const [filtroTelefone, setFiltroTelefone] = useState('');
  // Filtro por origem da oportunidade: todos | sdr | closer
  const [filtroCargo, setFiltroCargo] = useState('todos');
  // ⭐ mostra só as negociações favoritas (vale no Kanban e no Funil)
  const [filtroFavoritas, setFiltroFavoritas] = useState(false);
  // Visão: kanban (colunas) ou funil — a preferência fica salva no navegador
  const [visao, setVisaoState] = useState(localStorage.getItem('crmVisao') || 'kanban');
  const setVisao = (v) => { setVisaoState(v); localStorage.setItem('crmVisao', v); };
  const [modalGravar, setModalGravar] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [arrastando, setArrastando] = useState(null);
  const [sobreEtapa, setSobreEtapa] = useState(null);
  const [modalNova, setModalNova] = useState(false);
  // Tarefa criada JUNTO com a oportunidade (null = seção recolhida)
  const [tarefaJunto, setTarefaJunto] = useState(null);
  const [form, setForm] = useState({ nome_cliente: '', telefone: '', sdr: '', closer: '', etapa: 'lead' });
  const [salvando, setSalvando] = useState(false);
  const kanbanRef = useRef(null);
  const scrollMirrorRef = useRef(null);
  const scrollingFrom = useRef(null);
  const [detalhe, setDetalhe] = useState(null);
  const [editandoId, setEditandoId] = useState(null);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiFetch('/oportunidades');
      setOportunidades(data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  const atualizarSilenciosamente = useCallback(async () => {
    if (arrastando || modalNova || detalhe || editandoId) return;
    try {
      const data = await apiFetch('/oportunidades');
      setOportunidades(data);
    } catch (e) { console.error(e); }
  }, [arrastando, modalNova, detalhe, editandoId]);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    const idParam = searchParams.get('oportunidade');
    if (!idParam || oportunidades.length === 0) return;
    const op = oportunidades.find(o => o._id === idParam);
    if (op) setDetalhe(op);
  }, [searchParams, oportunidades]);

  // Botão flutuante: /crm?nova=1 já abre o modal de Nova Oportunidade
  useEffect(() => {
    if (searchParams.get('nova') === '1') {
      setForm(formNovaOportunidade());
      setEditandoId(null);
      setTarefaJunto(null);
      setModalNova(true);
    }
  }, [searchParams]);

  useEffect(() => {
    const intervalo = setInterval(atualizarSilenciosamente, 15000);
    return () => clearInterval(intervalo);
  }, [atualizarSilenciosamente]);

  useEffect(() => {
    const atualizar = () => {
      if (kanbanRef.current && scrollMirrorRef.current) {
        const inner = scrollMirrorRef.current.firstChild;
        if (inner) inner.style.width = kanbanRef.current.scrollWidth + 'px';
      }
    };
    atualizar();
    const obs = new ResizeObserver(atualizar);
    if (kanbanRef.current) obs.observe(kanbanRef.current);
    return () => obs.disconnect();
  }, [oportunidades, visao]);

  async function moverEtapa(op, novaEtapa) {
    if (op.etapa === novaEtapa) return;
    try {
      // Ganho é só uma coluna — o cliente nasce apenas pelo botão "Gravar Cliente"
      const atualizado = await apiFetch(`/oportunidades/${op._id}`, { method: 'PUT', body: JSON.stringify({ ...op, etapa: novaEtapa }) });
      setOportunidades(l => l.map(o => o._id === op._id ? atualizado : o));
      if (detalhe?._id === op._id) setDetalhe(atualizado);
    } catch (e) { alert(e.message); }
  }

  function onDragStart(e, op) { setArrastando(op); e.dataTransfer.effectAllowed = 'move'; }
  function onDragOver(e, etapaKey) { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; setSobreEtapa(etapaKey); }
  function onDrop(e, etapaKey) { e.preventDefault(); if (arrastando) moverEtapa(arrastando, etapaKey); setArrastando(null); setSobreEtapa(null); }

  async function salvar(e) {
    e.preventDefault();
    if (!editandoId && !(form.closer || '').trim()) {
      return alert('Selecione o closer que vai atender antes de lançar a oportunidade.');
    }
    if (!editandoId && tarefaJunto && !tarefaJunto.descricao.trim()) {
      return alert('Descreva a tarefa ou remova a seção (✕) antes de criar.');
    }
    setSalvando(true);
    // Origem SDR: quem prospectou é o SDR do formulário, registrado sozinho
    const payload = { ...form, origem_detalhe: form.origem_lead === 'SDR' ? (form.sdr || '') : (form.origem_detalhe || '') };
    try {
      if (editandoId) {
        const atualizado = await apiFetch(`/oportunidades/${editandoId}`, { method: 'PUT', body: JSON.stringify(payload) });
        setOportunidades(l => l.map(o => o._id === editandoId ? atualizado : o));
        if (detalhe?._id === editandoId) setDetalhe(atualizado);
      } else {
        const nova = await apiFetch('/oportunidades', { method: 'POST', body: JSON.stringify(payload) });
        setOportunidades(l => [nova, ...l]);
        // Tarefa criada junto, já vinculada à oportunidade recém-criada
        if (tarefaJunto && tarefaJunto.descricao.trim()) {
          await fetch('/agenda', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
            body: JSON.stringify({ ...tarefaJunto, oportunidade_id: nova._id, oportunidade_nome: nova.nome_cliente }),
          }).catch(() => {});
        }
      }
      setModalNova(false);
      setEditandoId(null);
      setTarefaJunto(null);
    } catch (e) { alert(e.message); }
    finally { setSalvando(false); }
  }

  function abrirEditar(op) {
    setForm({ nome_cliente: op.nome_cliente, telefone: op.telefone || '', sdr: op.sdr || '', closer: op.closer || '', etapa: op.etapa, origem_lead: op.origem_lead || '', origem_detalhe: op.origem_detalhe || '' });
    setEditandoId(op._id);
    setDetalhe(null);
    setModalNova(true);
  }

  async function excluir(op) {
    if (!window.confirm(`Excluir a oportunidade de "${op.nome_cliente}"?`)) return;
    await apiFetch(`/oportunidades/${op._id}`, { method: 'DELETE' });
    setOportunidades(l => l.filter(x => x._id !== op._id));
    setDetalhe(null);
  }

  // ⭐ marca/desmarca a negociação (otimista, igual à Agenda)
  async function alternarFavorita(op) {
    const nova = !op.favorita;
    setOportunidades(prev => prev.map(x => x._id === op._id ? { ...x, favorita: nova } : x));
    await fetch(`/oportunidades/${op._id}/favorita`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ favorita: nova }),
    }).catch(() => {});
  }

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#6b7280', fontSize: 13 }}>Carregando...</div>;

  const filtradas = oportunidades.filter(op => {
    if (filtroFavoritas && !op.favorita) return false;
    if (filtroCargo !== 'todos') {
      // Registros novos têm criado_por_cargo; nos antigos, inferimos:
      // SDR preenchido = criada por SDR; sem SDR = criada pelo closer.
      const origem = op.criado_por_cargo || (op.sdr ? 'sdr' : 'closer');
      if (origem !== filtroCargo) return false;
    }
    if (filtroCloser && op.closer !== filtroCloser) return false;
    if (filtroTelefone) {
      const busca = filtroTelefone.trim().toLowerCase();
      const tel = filtroTelefone.replace(/\D/g, '');
      const opTel = (op.telefone || '').replace(/\D/g, '');
      const opNome = (op.nome_cliente || '').toLowerCase();
      const matchTel = tel.length > 0 && opTel.includes(tel);
      const matchNome = opNome.includes(busca);
      if (!matchTel && !matchNome) return false;
    }
    return true;
  });

  // ── Visão funil: usa as MESMAS oportunidades filtradas e o mesmo
  // arrastar/soltar do kanban — só muda a forma de enxergar ──
  const caixaFunil = (etapaKey, largura = '100%', opts = {}) => {
    const etapa = ETAPAS.find(e => e.key === etapaKey);
    const cards = filtradas.filter(op => op.etapa === etapaKey);
    const sobre = sobreEtapa === etapaKey && arrastando?.etapa !== etapaKey;
    return (
      <div
        onDragOver={e => onDragOver(e, etapaKey)}
        onDrop={e => onDrop(e, etapaKey)}
        onDragLeave={() => setSobreEtapa(null)}
        style={{
          width: largura, margin: '0 auto', borderRadius: 10, background: '#fff',
          border: opts.lateral ? '1.5px dashed #d6dde6' : `1.5px solid ${sobre ? etapa.cor : '#dbe2ea'}`,
          boxShadow: sobre
            ? `0 0 0 3px ${etapa.cor}33, 0 8px 20px rgba(10,22,40,0.12)`
            : opts.lateral ? 'none' : '0 2px 10px rgba(10,22,40,0.06)',
          transition: 'box-shadow 0.15s, border-color 0.15s', overflow: 'hidden',
        }}>
        <div style={{ padding: '6px 12px', background: `linear-gradient(90deg, ${etapa.bg}, #fff 75%)`, borderBottom: '1px solid #eef1f5', borderLeft: `4px solid ${etapa.cor}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 800, fontSize: 11.5, color: '#0a1628', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>{opts.icone ? `${opts.icone} ` : ''}{etapa.label.toUpperCase()}</span>
          <span style={{ background: etapa.cor, color: '#fff', borderRadius: 999, padding: '1px 9px', fontSize: 11, fontWeight: 800, minWidth: 14, textAlign: 'center', boxShadow: `0 2px 6px ${etapa.cor}55` }}>{cards.length}</span>
        </div>
        <div style={{ padding: 8, display: 'flex', flexWrap: 'wrap', gap: 6, minHeight: 36, maxHeight: 150, overflowY: 'auto', justifyContent: opts.lateral ? 'flex-start' : 'center', background: opts.lateral ? '#fbfcfd' : '#fff' }}>
          {cards.map(op => (
            <div key={op._id} draggable
              onDragStart={e => onDragStart(e, op)}
              onDragEnd={() => { setArrastando(null); setSobreEtapa(null); }}
              onClick={() => setDetalhe(op)}
              title={[op.telefone, op.sdr && `SDR: ${op.sdr}`, op.closer && `Closer: ${op.closer}`].filter(Boolean).join(' · ') || op.nome_cliente}
              onMouseEnter={e => { if (arrastando?._id !== op._id) { e.currentTarget.style.boxShadow = `0 3px 10px ${etapa.cor}44`; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.borderColor = etapa.cor; } }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(10,22,40,0.08)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderColor = '#dbe2ea'; }}
              style={{
                display: 'flex', alignItems: 'center', gap: 6, background: '#fff',
                border: `1px solid ${arrastando?._id === op._id ? etapa.cor : '#dbe2ea'}`, borderRadius: 999,
                padding: '3px 10px', fontSize: 11.5, fontWeight: 600, color: '#0a1628', cursor: 'grab',
                opacity: arrastando?._id === op._id ? 0.5 : 1, maxWidth: '100%',
                boxShadow: '0 1px 3px rgba(10,22,40,0.08)', transition: 'box-shadow 0.12s, transform 0.12s, border-color 0.12s',
              }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: etapa.cor, flexShrink: 0 }} />
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 170 }}>{op.nome_cliente}</span>
            </div>
          ))}
          {cards.length === 0 && <span style={{ color: '#d1d5db', fontSize: 11, padding: '4px 2px' }}>Nenhuma oportunidade</span>}
        </div>
      </div>
    );
  };
  // Trapézio colorido entre as fases — é ele que desenha a silhueta do funil
  const conectorFunil = (deKey, paraKey, deW, paraW, txt) => {
    const de = ETAPAS.find(e => e.key === deKey).cor;
    const para = ETAPAS.find(e => e.key === paraKey).cor;
    const inset = (100 - (paraW / deW) * 100) / 2;
    return (
      <div style={{ width: `${deW}%`, margin: '0 auto' }}>
        <div style={{
          height: 26, clipPath: `polygon(0 0, 100% 0, ${100 - inset}% 100%, ${inset}% 100%)`,
          background: `linear-gradient(180deg, ${de}2b, ${para}42)`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {txt && <span style={{ fontSize: 9.5, fontWeight: 800, color: '#5b6b7f', letterSpacing: '0.08em' }}>{txt}</span>}
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* Assistente Gravar Cliente (única porta de entrada de cliente novo) */}
      {modalGravar && (
        <ModalGravarCliente
          op={modalGravar}
          onFechar={() => setModalGravar(null)}
          onGravado={() => { setModalGravar(null); setDetalhe(null); carregar(); }}
        />
      )}

      {modalNova && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 4, width: '100%', maxWidth: 460, border: '1px solid #c8d0da' }}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '4px 4px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontSize: 13, fontWeight: 700 }}>{editandoId ? 'Editar Oportunidade' : 'Nova Oportunidade'}</span>
              <button onClick={() => { setModalNova(false); setEditandoId(null); }} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
            </div>
            <form onSubmit={salvar} style={{ padding: '10px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <label style={lbl}>Nome do Cliente <span style={{ color: '#dc2626' }}>*</span></label>
                <input style={inp} value={form.nome_cliente} onChange={e => setForm(f => ({ ...f, nome_cliente: e.target.value }))} placeholder="Nome do cliente" required />
              </div>
              <div>
                <label style={lbl}>Telefone</label>
                <input style={inp} value={form.telefone} onChange={e => setForm(f => ({ ...f, telefone: e.target.value }))} placeholder="(11) 99999-9999" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div>
                  <label style={lbl}>SDR</label>
                  <SelectColaborador value={form.sdr} onChange={v => setForm(f => ({ ...f, sdr: v }))} placeholder="Selecione o SDR" />
                </div>
                <div>
                  <label style={lbl}>Closer</label>
                  <SelectColaborador apenasClosers value={form.closer} onChange={v => setForm(f => ({ ...f, closer: v }))} placeholder="Selecione o Closer" />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div>
                  <label style={lbl}>Etapa</label>
                  <select style={inp} value={form.etapa} onChange={e => setForm(f => ({ ...f, etapa: e.target.value }))}>
                    {ETAPAS.map(e => <option key={e.key} value={e.key}>{e.label}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Origem</label>
                  <select style={inp} value={form.origem_lead || ''} onChange={e => setForm(f => ({ ...f, origem_lead: e.target.value }))}>
                    <option value="">— selecionar —</option>
                    {ORIGENS_OP.map(o => <option key={o} value={o}>{o}</option>)}
                  </select>
                </div>
              </div>
              {form.origem_lead === 'SDR' && (
                <div style={{ fontSize: 11.5, color: '#0369a1', background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 5, padding: '5px 10px', marginTop: -2 }}>
                  📞 Quem prospectou: <strong>{form.sdr || '(selecione o SDR acima)'}</strong> — registrado automaticamente como detalhe da origem.
                </div>
              )}

              {/* Tarefa criada junto com a oportunidade — tudo de uma vez */}
              {!editandoId && (tarefaJunto === null ? (
                <button type="button"
                  onClick={() => setTarefaJunto({ descricao: '', data_agendada: '', destinado_a: localStorage.getItem('nomeUsuario') || '', favorita: false, urgente: false, subagenda: 'comercial' })}
                  style={{ background: '#f9fafb', border: '1px dashed #c8d0da', borderRadius: 6, padding: '8px 12px', fontSize: 12.5, fontWeight: 600, color: '#374151', cursor: 'pointer', textAlign: 'left' }}>
                  📝 + Adicionar tarefa junto <span style={{ fontWeight: 400, color: '#9ca3af' }}>(já nasce vinculada à oportunidade)</span>
                </button>
              ) : (
                <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 10, background: '#f9fafb', display: 'grid', gap: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>📝 Tarefa da oportunidade</span>
                    <button type="button" onClick={() => setTarefaJunto(null)} title="Remover a tarefa" style={{ background: 'none', border: 'none', color: '#9ca3af', fontSize: 14, cursor: 'pointer', lineHeight: 1 }}>✕</button>
                  </div>
                  <div>
                    <label style={lbl}>Descrição *</label>
                    <textarea value={tarefaJunto.descricao} onChange={e => setTarefaJunto(t => ({ ...t, descricao: e.target.value }))} rows={2}
                      placeholder="Ex.: ligar amanhã pra apresentar proposta…"
                      style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' }} />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    <div>
                      <label style={lbl}>Data <span style={{ fontWeight: 400, color: '#9ca3af' }}>(hora opcional)</span></label>
                      <DataHoraInput value={tarefaJunto.data_agendada} onChange={v => setTarefaJunto(t => ({ ...t, data_agendada: v }))} inpStyle={inp} />
                    </div>
                    <div>
                      <label style={lbl}>Destinado a</label>
                      <SelectColaborador value={tarefaJunto.destinado_a} onChange={v => setTarefaJunto(t => ({ ...t, destinado_a: v }))} placeholder="Selecione..." />
                    </div>
                  </div>
                  <div>
                    <button type="button" onClick={() => setTarefaJunto(t => ({ ...t, favorita: !t.favorita }))} title="Favorita: aparece no filtro ⭐ da Agenda em qualquer dia" style={{ background: tarefaJunto.favorita ? '#fffbeb' : '#fff', color: tarefaJunto.favorita ? '#b45309' : '#6b7280', border: `1px solid ${tarefaJunto.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{tarefaJunto.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}</button>
                    <button type="button" onClick={() => setTarefaJunto(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: tarefaJunto.urgente ? '#fee2e2' : '#fff', color: tarefaJunto.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${tarefaJunto.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{tarefaJunto.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
                  </div>
                </div>
              ))}
              <div style={{ display: 'flex', gap: 8, paddingTop: 4, borderTop: '1px solid #e8eaed', marginTop: 4 }}>
                <button type="submit" disabled={salvando} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontWeight: 600, fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer' }}>{salvando ? 'Salvando...' : editandoId ? 'Salvar' : 'Criar'}</button>
                <button type="button" onClick={() => { setModalNova(false); setEditandoId(null); }} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', fontSize: 12, border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer' }}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {detalhe && (
        <ModalDetalhe
          op={detalhe}
          etapas={ETAPAS}
          onFechar={() => setDetalhe(null)}
          onMover={(op, etapa) => moverEtapa(op, etapa)}
          onEditar={abrirEditar}
          onExcluir={excluir}
          onGravarCliente={(op) => setModalGravar(op)}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>CRM</h1>
          <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>{filtradas.length} oportunidade(s) — clique para abrir, arraste para mover</p>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Liga/desliga da visão: Kanban ⇄ Funil (os filtros valem nas duas) */}
          <div style={{ display: 'flex', border: '1px solid #d1d5db', borderRadius: 4, overflow: 'hidden' }}>
            {[['kanban', '📋 Kanban'], ['funil', '🔻 Funil']].map(([v, rotulo]) => (
              <button key={v} onClick={() => setVisao(v)} style={{
                background: visao === v ? '#0a1628' : '#fff',
                color: visao === v ? '#fff' : '#374151',
                padding: '4px 12px', fontSize: 12, border: 'none', cursor: 'pointer', fontWeight: 600,
              }}>{rotulo}</button>
            ))}
          </div>
          {/* Filtro por origem: TODOS / SDR / CLOSER */}
          <div style={{ display: 'flex', border: '1px solid #d1d5db', borderRadius: 4, overflow: 'hidden' }}>
            {[['todos', 'TODOS'], ['sdr', 'SDR'], ['closer', 'CLOSER']].map(([v, rotulo]) => (
              <button key={v} onClick={() => setFiltroCargo(v)} style={{
                background: filtroCargo === v ? '#0a1628' : '#fff',
                color: filtroCargo === v ? '#fff' : '#374151',
                padding: '4px 12px', fontSize: 12, border: 'none', cursor: 'pointer', fontWeight: 600,
              }}>{rotulo}</button>
            ))}
          </div>
          {/* ⭐ só as negociações favoritas */}
          <button onClick={() => setFiltroFavoritas(f => !f)} title="Mostrar só as negociações marcadas com ⭐"
            style={{ background: filtroFavoritas ? '#b45309' : '#fffbeb', color: filtroFavoritas ? '#fff' : '#b45309', border: `1px solid ${filtroFavoritas ? '#b45309' : '#fde68a'}`, borderRadius: 4, padding: '4px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
            ⭐ Favoritas
          </button>
          <button onClick={() => { setForm(formNovaOportunidade()); setEditandoId(null); setTarefaJunto(null); setModalNova(true); }} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer', fontWeight: 600 }}>+ Nova Oportunidade</button>
          <div style={{ position: 'relative' }}>
            <input
              value={filtroTelefone}
              onChange={e => setFiltroTelefone(e.target.value)}
              placeholder="Filtrar por nome ou telefone..."
              style={{ ...inp, width: 160, paddingRight: filtroTelefone ? 28 : 12 }}
            />
            {filtroTelefone && (
              <button onClick={() => setFiltroTelefone('')} style={{
                position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', color: '#9ca3af', fontSize: 14, cursor: 'pointer', padding: 0, lineHeight: 1,
              }}>✕</button>
            )}
          </div>
          <select value={filtroCloser} onChange={e => setFiltroCloser(e.target.value)} style={{ ...inp, width: 'auto', minWidth: 160 }}>
            <option value="">Todos os closers</option>
            {[...new Set(oportunidades.map(op => op.closer).filter(Boolean))].sort().map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>
      </div>

      {/* ── Visão FUNIL ── */}
      {visao === 'funil' && (
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', paddingBottom: 12, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 320, background: 'linear-gradient(180deg, #fbfcfe, #f4f7fa)', border: '1px solid #e6ebf1', borderRadius: 14, padding: '14px 16px 16px' }}>
            {/* Lead: em cima, antes de entrar no funil */}
            {caixaFunil('lead', '100%', { icone: '📥' })}
            {conectorFunil('lead', '1contato', 100, 90, 'ENTRAM NO FUNIL ▾')}
            {/* As 3 fases do funil, afunilando */}
            {caixaFunil('1contato', '90%', { icone: '📞' })}
            {conectorFunil('1contato', 'viabilidade', 90, 72)}
            {caixaFunil('viabilidade', '72%', { icone: '🔎' })}
            {conectorFunil('viabilidade', 'negociacao', 72, 54)}
            {caixaFunil('negociacao', '54%', { icone: '🤝' })}
            {conectorFunil('negociacao', 'ganho', 54, 40, 'FECHAM ▾')}
            {/* Ganho: fora do funil, embaixo */}
            {caixaFunil('ganho', '40%', { icone: '🏆' })}
          </div>
          {/* Caixinhas de lado — fora do funil */}
          <div style={{ width: 240, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div style={{ fontSize: 10, fontWeight: 800, color: '#9ca3af', letterSpacing: '0.08em', padding: '2px 2px 0' }}>FORA DO FUNIL</div>
            {caixaFunil('perdido', '100%', { lateral: true, icone: '🚫' })}
            {caixaFunil('sem-interacao', '100%', { lateral: true, icone: '😴' })}
          </div>
        </div>
      )}

      {/* ── Visão KANBAN ── */}
      {visao === 'kanban' && (<>
      {/* Scroll espelho no topo */}
      <div
        ref={scrollMirrorRef}
        onScroll={() => {
          if (scrollingFrom.current === 'kanban') return;
          scrollingFrom.current = 'mirror';
          if (kanbanRef.current) kanbanRef.current.scrollLeft = scrollMirrorRef.current.scrollLeft;
          clearTimeout(scrollMirrorRef._t);
          scrollMirrorRef._t = setTimeout(() => { scrollingFrom.current = null; }, 50);
        }}
        className="kanban-scroll-mirror"
        style={{ overflowX: 'scroll', overflowY: 'hidden', height: 14, marginBottom: 4 }}
      >
        <div style={{ height: 1, width: kanbanRef.current ? kanbanRef.current.scrollWidth : '100%' }} />
      </div>

      {/* Kanban */}
      <div
        ref={kanbanRef}
        onScroll={() => {
          if (scrollingFrom.current === 'mirror') return;
          scrollingFrom.current = 'kanban';
          if (scrollMirrorRef.current) scrollMirrorRef.current.scrollLeft = kanbanRef.current.scrollLeft;
          clearTimeout(kanbanRef._t);
          kanbanRef._t = setTimeout(() => { scrollingFrom.current = null; }, 50);
        }}
        className="kanban-scroll"
        style={{ display: 'flex', gap: 8, overflowX: 'scroll', alignItems: 'stretch', paddingBottom: 12,
          // Quadro preso à altura da janela: quem rola é CADA COLUNA, não a página
          height: 'calc(100vh - 240px)', minHeight: 340 }}>
        {ETAPAS.map(etapa => {
          const cards = filtradas.filter(op => op.etapa === etapa.key);
          const sobre = sobreEtapa === etapa.key && arrastando?.etapa !== etapa.key;
          return (
            <div key={etapa.key}
              onDragOver={e => onDragOver(e, etapa.key)}
              onDrop={e => onDrop(e, etapa.key)}
              onDragLeave={() => setSobreEtapa(null)}
              style={{ minWidth: 200, flex: '0 0 200px', borderRadius: 4, border: `2px solid ${sobre ? etapa.cor : '#c8d0da'}`, background: sobre ? etapa.bg : '#f9fafb', transition: 'border-color 0.15s, background 0.15s',
                display: 'flex', flexDirection: 'column', maxHeight: '100%' }}>

              <div style={{ padding: '6px 10px', borderBottom: '1px solid #e8eaed', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: etapa.cor }} />
                  <span style={{ fontWeight: 700, fontSize: 12, color: '#0a1628' }}>{etapa.label}</span>
                </div>
                <span style={{ background: etapa.cor, color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 700 }}>{cards.length}</span>
              </div>

              {/* Área dos cards: rolagem própria por coluna */}
              <div style={{ padding: 8, display: 'flex', flexDirection: 'column', gap: 6, minHeight: 60, flex: 1, overflowY: 'auto' }}>
                {cards.map(op => (
                  <div key={op._id}
                    draggable
                    onDragStart={e => onDragStart(e, op)}
                    onDragEnd={() => { setArrastando(null); setSobreEtapa(null); }}
                    onClick={() => setDetalhe(op)}
                    style={{
                      background: op.favorita ? '#fffbeb' : '#fff', borderRadius: 4, padding: '8px 10px',
                      border: `1px solid ${arrastando?._id === op._id ? etapa.cor : op.favorita ? '#fde68a' : '#c8d0da'}`,
                      cursor: 'grab', opacity: arrastando?._id === op._id ? 0.5 : 1,
                      transition: 'box-shadow 0.15s',
                    }}
                    onMouseEnter={e => { if (arrastando?._id !== op._id) e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
                      <div style={{ fontWeight: 700, fontSize: 12, color: '#0a1628', display: 'flex', alignItems: 'flex-start', gap: 4, minWidth: 0 }}>
                        <button onClick={e => { e.stopPropagation(); alternarFavorita(op); }}
                          title={op.favorita ? 'Tirar dos favoritos' : 'Marcar como favorita (aparece no filtro ⭐)'}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, padding: 0, lineHeight: 1.2, opacity: op.favorita ? 1 : 0.4, flexShrink: 0 }}>
                          {op.favorita ? '⭐' : '☆'}
                        </button>
                        <span>{op.nome_cliente}</span>
                      </div>
                      {op.telefone && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 3, marginLeft: 6, flexShrink: 0 }}>
                          <button
                            onClick={e => { e.stopPropagation(); window.open(`https://web.whatsapp.com/send?phone=${(op.whatsapp_tel || op.telefone).replace(/\D/g, '')}`, '_blank'); }}
                            title="Abrir WhatsApp"
                            style={{ background: '#25d366', color: '#fff', border: 'none', borderRadius: 4, padding: '2px 7px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                            💬
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              const num = op.telefone.replace(/\D/g, '');
                              if (navigator.clipboard) {
                                navigator.clipboard.writeText(num).catch(() => {
                                  const el = document.createElement('textarea');
                                  el.value = num; document.body.appendChild(el); el.select();
                                  document.execCommand('copy'); document.body.removeChild(el);
                                });
                              } else {
                                const el = document.createElement('textarea');
                                el.value = num; document.body.appendChild(el); el.select();
                                document.execCommand('copy'); document.body.removeChild(el);
                              }
                            }}
                            title="Copiar número"
                            style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '2px 7px', fontSize: 11, cursor: 'pointer' }}>
                            📋
                          </button>
                        </div>
                      )}
                    </div>
                    {op.telefone && (
                      <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{op.telefone}</div>
                    )}
                    {op.sdr && <div style={{ fontSize: 11, color: '#6b7280', marginTop: 1 }}>SDR: {op.sdr}</div>}
                    {op.closer && <div style={{ fontSize: 11, color: '#6b7280', marginTop: 1 }}>Closer: {op.closer}</div>}
                    <div style={{ fontSize: 10, color: '#d1d5db', marginTop: 4 }}>{fmtD(op.criado_em)}</div>
                  </div>
                ))}
                {cards.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '12px 0', color: '#d1d5db', fontSize: 11 }}>Nenhuma oportunidade</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      </>)}
    </div>
  );
}
